export default {
  okText: '确认',
  closeText: '关闭',
  cancelText: '取消',
  loadingText: '加载中...',
  saveText: '保存',
  delText: '删除',
  topMenuAlignRight: '居中',
  resetText: '重置',
  searchText: '搜索',
  queryText: '查询',
  请填写手机号:'请填写手机号',
  请填写邮箱:'请填写邮箱',
  inputText: '请输入',
  chooseText: '请选择',
  '添加角色':'添加角色',
  mainPage: '首页',

  redo: '刷新',
  back: '返回',

  light: '亮色主题',
  dark: '黑暗主题',

  星期一:"星期一",
  星期二:"星期二",
  星期三:"星期三",
  星期四:"星期四",
  星期五:"星期五",

};
